import { ContextMenuItem } from '../../../buildingBlocks/context-menu/context-menu.types';
import { chatbotActionButton } from '../../../components/action-buttons/action-buttons.consts';
import { ButtonColor } from '../../../components/action-buttons/action-buttons.types';
import { InvoiceFilter } from './invoicing.types';

export const defaultFormValues: InvoiceFilter = {
  accountingEnterDateFrom: { value: '' },
  accountingEnterDateTo: { value: '' },
  clearingDateFrom: { value: '' },
  clearingDateTo: { value: '' },
  dateFrom: { value: '' },
  dateTo: { value: '' },
  flags: { value: '' },
  invoiceNumber: { value: '' },
  issueDateFrom: { value: '' },
  issueDateTo: { value: '' },
  paymentScheduleDateFrom: { value: '' },
  paymentScheduleDateTo: { value: '' },
  plants: { value: [] },
  purchaseOrder: { value: '' },
  purchasingOrganisation: { value: [] },
  status: { value: [] },
  vendorCode: { value: '' },
  vendorCodes: { value: '' },
};

export const DOWNLOAD_MENU_ITEMS: ContextMenuItem[] = [
  { icon: 'download', label: 'XLSX', name: 'xlsx' },
  { icon: 'download', label: 'XLSXs (zip)', name: 'xlsx-zip' },
  { icon: 'download', label: 'PDFs (zip)', name: 'pdf-zip' },
  { icon: 'download', label: 'XML', name: 'xml' },
];

export const INVOICING_DOWNLOAD_ACTION = 'DOWNLOAD_INVOICES';

export const invoicingActionButtons = [
  {
    color: ButtonColor.Blue,
    icon: 'download',
    menuItems: DOWNLOAD_MENU_ITEMS,
    name: INVOICING_DOWNLOAD_ACTION,
    tooltipKey: 'commits.download',
  },
  chatbotActionButton('CHATBOT'),
];

/** User-settings key the invoicing column arrangement is stored under. */
export const INVOICING_COLUMN_LIST = 'column_list-invoicing';

/** Form key naming the fields this plant allows on the invoicing grid. */
export const INVOICING_FIELDS_KEY = 'INVOICE_MODULE_FORMKEY';

/** Namespace the invoicing column captions are translated from, by field name. */
export const INVOICING_COLUMN_LABEL_PREFIX = 'defaultFields.financial-module.';

/** Kept so a second click reuses the dialog rather than opening another. */
export const INVOICING_COLUMNS_DIALOG_ID = 'invoicing-select-columns-dialog';

export const INVOICING_TEST_IDS = { columnSelect: 'invoicing-column-select' } as const;
